export const frameNames = {
  PgLogo: 'pgLogo',
  MuteIcon: 'muteIcon',
  MuteIconMobile: 'muteIconMobile',
  SwitchOn: 'switchOn',
  PumaMode: 'pumaMode',
  SwitchOff: 'switchOff',
  Burger: 'burger',
  BurgerPressed: 'burgerPressed',
  SoundIcon: 'soundIcon',
  SoundIconMobile: 'soundIconMobile',
  SlowSpinIcon: 'slowSpinIcon',
  InfinityIcon: 'infinitiIcon',
  Infinity: 'infinity',
  FastSpinIcon: 'fastSpinIcon',
  AutoBetButton: 'autoBetButton',
  FullScreenIcon: 'fullScreenIcon',
  OpenMenuBarIcon: 'openMenuBarIcon',
  OpenMenuBarIconMobile: 'openMenuBarIconMobile',
  BigLogo: 'bigLogo',
  AutoBetStopIcon: 'autoBetStopIcon',
  CloseMenuBarIcon: 'closeMenuBarIcon',
  CloseMenuBarIconMobile: 'closeMenuBarIconMobile',
  PaytablePlayHover: 'paytablePlayHover',
  PaytablePlayPressing: 'paytablePlayPressing',
  PaytablePlay: 'paytablePlay',
  SpinButtonStandardState: 'spinButton',
  AutoBetEnableIcon: 'autoBetEnableIcon',
  HoverBetButtonState: 'hoverBetButtonState',
  SelectedHoverButton: 'selectedHoverButton',
  CloseFullScreenIcon: 'closeFullScreenIcon',
  NormalBetButtonState: 'normalBetButtonState',
  ClickedBetButtonState: 'clickedBetButtonState',
  PaytablearrowRightPressed: 'paytablearrowRightPressed',
  PaytablearrowLeftPressed: 'paytablearrowLeftPressed',
  PaytablearrowRightHover: 'paytablearrowRightHover',
  PaytablearrowLeftHover: 'paytablearrowLeftHover',
  PaytablearrowRight: 'paytablearrowRight',
  PaytablearrowLeft: 'paytablearrowLeft',
  SelectedQuickBetState: 'selectedBetStateButton',
  BetButtonsLeftArrow: 'betButtonsLeftArrow',
  BetButtonsLeftArrowDisabled: 'betButtonsLeftArrowDisabled',
  BetButtonsLeftArrowHovered: 'betButtonsLeftArrowHovered',
  BetButtonsLeftArrowPressed: 'betButtonsLeftArrowPressed',
  BetButtonsRightArrow: 'betButtonsRightArrow',
  BetButtonsRightArrowDisabled: 'betButtonsRightArrowDisabled',
  BetButtonsRightArrowHovered: 'betButtonsRightArrowHovered',
  BetButtonsRightArrowPressed: 'betButtonsRightArrowPressed',
  Reconnect: 'reconnect',
  Reconnect2: 'reconnect2',
  WifiLost: 'wifiLost',
  ShapeError: 'shapeError',
  ShapeWarning: 'shapeWarning',
  NotificationError: 'notificationError',
  Maintenance: 'maintenance',
  Shape: 'shape',
  SelectedBetButtonState: 'selectedBetButtonState',
  InfoIcon: 'infoIcon',
  SettingsIcon: 'settingsIcon',
  GameRulesIcon: 'gameRulesIcon',
  InfoIconSelected: 'infoIconSelected',
  SettingsIconSelected: 'settingsIconSelected',
  GameRulesIconSelected: 'gameRulesIconSelected',
  PayTableDisableRound: 'payTableDisableRound',
  PayTableActiveRound: 'payTableActiveRound',
  PressedCollectIcon: 'pressedCollectIcon',
  CollectIcon: 'collectIcon',
  GambleStartButton: 'gambleStartButton',
  HistoryBlackCard: 'historyBlackCard',
  HistoryRedCard: 'historyRedCard',
  RedButtonHovered: 'redButtonHovered',
  RedButtonPressed: 'redButtonPressed',
  RedButtonStandard: 'redButtonStandard',
  BlackButtonHovered: 'blackButtonHovered',
  BlackButtonPressed: 'blackButtonPressed',
  BlackButtonStandard: 'blackButtonStandard',
  CollectButtonPressed: 'collectButtonPressed',
  CollectButtonStandard: 'collectButtonStandard',
  GambleStartButtonContainer: 'gambleStartButtonContainer',
};
